module.exports = __webpack_public_path__ + "static/img/gallery-image-item.5cb33dba.png";